// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import moment from 'moment';

const FinancialAccountsTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="FinancialAccounts"
      pageIcon={AccountBalanceWalletIcon}
      addButtonLabel="AddNewFinancialAccount"
      
      // ============ NAVIGATION URLs ============
      addPageUrl="/settlements/FinancialAccounts/new"
      viewPageUrl="/settlements/FinancialAccounts/:id"
      editPageUrl="/settlements/FinancialAccounts/:id/edit?came_from=all"
      
      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts`}
      getApiMethod="GET"
      
      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts/:id`}
      deleteApiMethod="DELETE"
      
      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.financialAccounts"
      responsePaginationPath="data.data.pagination"
      
      // ============ TABLE CONFIGURATION ============
      idField="id"
      columns={[
        {
          field: 'name',
          headerKey: 'Name',
          align: 'center',
        },
        {
          field: 'account_number',
          headerKey: 'AccountNumber',
          align: 'center',
        },
        {
          field: 'organisation_en_name',
          headerKey: 'Organisation',
          align: 'center',
          render: (value, row) => (
            currentLanguageCode === 'en-us' ? row.organisation_en_name : row.organisation_ar_name
          ),
        },
        {
          field: 'account_type_en',
          headerKey: 'AccountType',
          align: 'center',
          render: (value, row) => (
            currentLanguageCode === 'en-us' ? row.account_type_en : row.account_type_ar
          ),
        },
        {
          field: 'balance',
          headerKey: 'Balance',
          align: 'center',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
        },
      ]}
      
      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchFinancialAccountPlaceholder"
      searchInputWidth="390px"
      
      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'organisation_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
        {
          name: 'financial_account_type_id',
          labelKey: 'AccountType',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-account-types`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.type_en : item.type_ar,
          },
        },
      ]}
      
      // ============ PERMISSIONS ============
      subsystemName="FinancialAccounts"
      
      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteFinancialAccount"
    />
  );
};

export default FinancialAccountsTable;